import React from "react";

const Section = ({ title, children }) => {
  return (
    <section className="a11y-section">
      <h3 className="a11y-section-title">{title}</h3>

      {children}
    </section>
  );
};

export default Section;
